import React, {useEffect, useState} from 'react';
import BaseContainer from "../containers/common/BaseContainer";
import QuestionBoard from "../containers/QuestrionBoard";
import WriteForm from "../containers/WriteForm";
import ViewForm from "../containers/ViewForm";

const QuestionBoardPage = (props) => {
    const [viewState, setViewState] = useState("LIST");
    const [reTitle, setReTitle] = useState("");

    useEffect(() => {
        if (props.match.params.brdNo) {
            setViewState("VIEW");
        }
    }, []);

    const renderContent = () => {
        switch (viewState) {
            case "LIST":
                return <QuestionBoard setViewState={setViewState} />;
            case "VIEW":
                return <ViewForm setViewState={setViewState} brdNo={props.match.params.brdNo} setReTitle={setReTitle} />;
            case "WRITE":
                return <WriteForm setViewState={setViewState} reTitle={reTitle} brdNo={props.match.params.brdNo} />;
            default:
                break;
        }
    }
    return (
        viewState !== "" &&
        <>
            <BaseContainer sidebar={true}>
                {renderContent()}
            </BaseContainer>
        </>
    )
};

export default QuestionBoardPage;
